import { Table } from 'antd';
import {
  GameEnvRegion,
  GameEnvType,
  IGameEnvModel,
} from '../../../model/api-modules/env';
import { getEnvNameByValue } from '../../utils/env';
import { getFormatDateTime } from '../../../lib';
import devImg from '../../../assets/img/dev-big.png';
import liveImg from '../../../assets/img/live-big.png';
import getFormatMessage from '../../../locales/get-format-message';

interface IProps {
  readonly loading: boolean;
  readonly envList: IGameEnvModel[] | [];
}

export const GameEnvList = (props: IProps) => {
  const { loading, envList } = props;

  const COLUMNS = [
    {
      title: getFormatMessage('tag'),
      dataIndex: 'Name',
      key: 'Env',
      render: (_text: string, record: IGameEnvModel) => {
        return (
          <div className="first-column">
            <img
              src={record.Type === GameEnvType.Live ? liveImg : devImg}
              style={{ width: 40, height: 20 }}
            />
          </div>
        );
      },
    },
    {
      title: getFormatMessage('env_name'),
      dataIndex: 'Name',
      key: 'Name',
    },
    {
      title: getFormatMessage('region'),
      dataIndex: 'Region',
      key: 'Region',
      render: (Region: GameEnvRegion) => {
        const displayText = getEnvNameByValue(Region);
        return <div>{displayText}</div>;
      },
    },
    {
      title: getFormatMessage('create_by'),
      dataIndex: 'FounderUid',
      key: 'FounderUid',
      render: (text: string) => {
        if (text) {
          return text;
        }
        return getFormatMessage('system');
      },
    },
    {
      title: getFormatMessage('created_time'),
      dataIndex: 'CreateTime',
      key: 'CreateTime',
      render: (text: Date) => {
        return getFormatDateTime(text);
      },
    },
  ];

  return (
    <div>
      <Table
        rowKey="id"
        loading={loading}
        dataSource={envList || []}
        columns={COLUMNS}
        pagination={{
          showTotal: (total) => {
            return getFormatMessage('total_items', {
              params: {
                total,
              },
            });
          },
        }}
      />
    </div>
  );
};
